module.exports = __webpack_public_path__ + "img/birds1-background.b25d62fa.png";